import React from "react";
import './styles.css';

/*const options = [
    { value: 0, label: "Inactivo", clase:'badge bg-primary' },
    { value: 1, label: "Activo", clase:'badge bg-warning text-dark' },
];*/

// Reusable Dropdown
class NuEstado extends React.Component { 
    // selectValue => current selected value
  
    state = {
      selectedOption: 0,/* lista de seleccioados */
    }
    
    // ------------------------------------------------------------------------
    onClickItem = (e,item) => {
      console.log("onChange");
      e.target.name = this.props.name;
      e.target.value = item.value;
      this.props.onChange(e);
    }; 
    //=======================================
    render() {
      const { name, value, options } = this.props;
      
       //const miClassName = `nu-sidenav_item ${ value===item.value? "menu-item--active":'' }`;
       
       return (
        <div className="side-menur">
          {
             //JSON.stringify( this.state.selectedOption ) 

          }
      
        
              {options.map( (item, index) => {
                return (
                  
                    <div key={index}  >

                      { item.value === value? 
                        <>
                        <span className={item.clase}>{item.label}</span>
                        </> :""
                      }                      
                      
                    </div>
                 
                );
              })}
          
        </div>
        );
     }
};
export default NuEstado;